"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rfidTagHaulerTypes = void 0;
exports.rfidTagHaulerTypes = {
    SET_DATA_GRID: 'RFID TAG HAULER TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'RFID TAG HAULER TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'RFID TAG HAULER TYPES ON MUTATION',
    ON_CHANGE_DATAITEM: 'RFID TAG HAULER TYPES ON CHANGE DATAITEM',
    ON_SAVE_DATAITEM: 'RFID TAG HAULER TYPES ON SAVE DATAITEM',
    GET_DETAIL: 'RFID TAG HAULER TYPES ON GET DETAIL',
    ON_FILTER_CHANGE: 'RFID TAG HAULER TYPES ON FILTER CHANGE',
    ON_SORT_CHANGE: 'RFID TAG HAULER TYPES ON SORT CHANGE',
    ON_DELETE: 'RFID TAG HAULER TYPES ON DELETE',
    SET_ERROR: 'RFID TAG HAULER TYPES REDUCER SET ERROR',
};
